import React from 'react';
import {Link} from 'react-router-dom';
import {useTheme} from '../../contexts/ThemeContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiFacebook, FiInstagram, FiMapPin} = FiIcons;

const Footer = () => {
  const {themeConfig} = useTheme();
  const {footer} = themeConfig;

  return (
    <footer className="bg-warm-brown text-cream py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-8">
          <div className="flex flex-col items-center space-y-4">
            <img src={footer.logo} alt="La Vie Saigon Logo" className="h-16 w-auto" />
            <h3 className="text-3xl font-playfair mb-2">{footer.title}</h3>
            <p className="text-cream/80 italic text-lg">{footer.slogan}</p>
          </div>

          <div className="flex justify-center gap-6">
            <a
              href={footer.facebookLink}
              className="bg-cream/10 p-3 rounded-full hover:bg-cream/20 transition-colors duration-300"
              aria-label="Facebook"
            >
              <SafeIcon icon={FiFacebook} className="text-xl" />
            </a>
            <a
              href={footer.instagramLink}
              className="bg-cream/10 p-3 rounded-full hover:bg-cream/20 transition-colors duration-300"
              aria-label="Instagram"
            >
              <SafeIcon icon={FiInstagram} className="text-xl" />
            </a>
            <a
              href={footer.mapsLink}
              className="bg-cream/10 p-3 rounded-full hover:bg-cream/20 transition-colors duration-300"
              aria-label="Google Maps"
            >
              <SafeIcon icon={FiMapPin} className="text-xl" />
            </a>
          </div>

          <nav aria-label="Legal" className="flex flex-wrap justify-center gap-6 text-sm">
            <Link
              to="/terms-of-use"
              className="text-cream/80 hover:text-cream underline underline-offset-4"
            >
              Terms of Use
            </Link>
            <Link
              to="/privacy-policy"
              className="text-cream/80 hover:text-cream underline underline-offset-4"
            >
              Privacy Policy
            </Link>
          </nav>

          <div className="border-t border-cream/20 pt-8">
            <p className="text-cream/70">{footer.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;